var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDoNotCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 3.5H7.50024C6.94796 3.5 6.50024 3.94772 6.50024 4.5V17.5C6.50024 18.0523 6.94796 18.5 7.50024 18.5H19.5002C20.0525 18.5 20.5002 18.0523 20.5002 17.5V4.5C20.5002 3.94772 20.0525 3.5 19.5002 3.5Z",
    fill: "#73A9EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 5.5H4.50024C3.94796 5.5 3.50024 5.94772 3.50024 6.5V19.5C3.50024 20.0523 3.94796 20.5 4.50024 20.5H16.5002C17.0525 20.5 17.5002 20.0523 17.5002 19.5V6.5C17.5002 5.94772 17.0525 5.5 16.5002 5.5Z",
    fill: "#94C6F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0627 8.875H8.93774C8.48901 8.875 8.12524 9.23877 8.12524 9.6875C8.12524 10.1362 8.48901 10.5 8.93774 10.5H12.0627C12.5115 10.5 12.8752 10.1362 12.8752 9.6875C12.8752 9.23877 12.5115 8.875 12.0627 8.875Z",
    fill: "#73A9EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3127 15.375H6.68774C6.30805 15.375 6.00024 15.6828 6.00024 16.0625C6.00024 16.4422 6.30805 16.75 6.68774 16.75H14.3127C14.6924 16.75 15.0002 16.4422 15.0002 16.0625C15.0002 15.6828 14.6924 15.375 14.3127 15.375Z",
    fill: "#D1E6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3127 12.5H6.68774C6.30805 12.5 6.00024 12.8078 6.00024 13.1875C6.00024 13.5672 6.30805 13.875 6.68774 13.875H14.3127C14.6924 13.875 15.0002 13.5672 15.0002 13.1875C15.0002 12.8078 14.6924 12.5 14.3127 12.5Z",
    fill: "#D1E6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8755 23.5C21.4298 23.5 23.5005 21.4293 23.5005 18.875C23.5005 16.3207 21.4298 14.25 18.8755 14.25C16.3212 14.25 14.2505 16.3207 14.2505 18.875C14.2505 21.4293 16.3212 23.5 18.8755 23.5Z",
    fill: "#F0464F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6715 20.6429C19.94 20.9114 20.3753 20.9114 20.6437 20.6429C20.9122 20.3744 20.9122 19.9391 20.6437 19.6706L18.0805 17.1073C17.812 16.8389 17.3767 16.8389 17.1082 17.1073C16.8397 17.3758 16.8397 17.8111 17.1082 18.0796L19.6715 20.6429Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1076 19.671C16.8391 19.9395 16.8391 20.3748 17.1076 20.6433C17.3761 20.9117 17.8114 20.9117 18.0799 20.6433L20.6431 18.08C20.9116 17.8115 20.9116 17.3762 20.6431 17.1077C20.3747 16.8392 19.9394 16.8392 19.6709 17.1077L17.1076 19.671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoNotCopy);
export default __webpack_public_path__ + "static/media/icon_do_not_copy.51bd4046.svg";
export { ForwardRef as ReactComponent };